// reducers/QuestionNumber.js

/**
 * Reducer for tracking the current question index.
 * @param {number} state - The current question index (default: 0).
 * @param {Object} action - Redux action.
 * @returns {number} The updated question index.
 */
const initialState = 0;

const questionReducer = (state = initialState, action) => {
  if (action.type === "SET_QUESTION") {
    // Sets the current question index to the payload value
    return action.payload;
  }
  // Returns the current state for any unrelated action
  return state;
};

export default questionReducer;
